




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { IEId } from '@signing-page/signing/types/eid';
import { ECriiptoStatus } from '@signing-page/signing/types/enums/criipto-status';
import { criiptoBaseUrl } from '@signing-page/signing/constants/criipto';

@Component({
  data: () => ({
    ECriiptoStatus,
  }),
})
export default class Criipto extends Vue {
  @Prop() selectedEId!: IEId;
  @Prop() documentId!: string;
  @Prop() recipientId: string;
  @Prop() status!: ECriiptoStatus;

  get showIframe(): boolean {
    return this.frameUrl && [ECriiptoStatus.Default, ECriiptoStatus.Error].includes(this.status);
  }

  get frameHeight(): number {
    return this.selectedEId.height;
  }

  get frameWidth(): number {
    const { width } = this.selectedEId;
    const eidHolder: Element = document.getElementsByClassName('eid-holder')[0];
    if (!eidHolder) {
      return width;
    }
    const clientWidth: number = eidHolder.getBoundingClientRect().width;
    if (clientWidth < this.selectedEId.width) {
      return clientWidth;
    }
    return width;
  }

  get frameUrl(): string {
    const { key } = this.selectedEId;
    return `${criiptoBaseUrl}/${key}/login?documentId=${this.documentId}&recipientId=${this.recipientId}`;
  }
}
